import { put } from 'redux-saga/effects';

import jsonApiRequest from 'rdx/api-utils/jsonApiRequest';
import {
  resetProcedureStepFiles,
  setProcedureStepFiles,
  setLoadingAllProcedureStepFiles,
  ProcedureStepFile,
} from 'rdx/modules/fileExplorer/slice';

/**
 * Saga that fetches ALL pages of files for a given file explorer link/action
 * and populates procedureStepFiles with every file across all pages.
 *
 * This is used in the procedure step file selection flow so that "Select Files"
 * selects all files in the folder, not just the first loaded page.
 */
function* fetchAllProcedureStepFiles(rdxAction: any) {
  const { link, params, query, action } = rdxAction.payload;

  yield put(setLoadingAllProcedureStepFiles(true));

  try {
    const allFiles: ProcedureStepFile[] = [];
    let currentPage = 1;
    let hasMore = true;

    while (hasMore) {
      const pageQuery = { ...query, page: currentPage };

      const response: any = yield* jsonApiRequest({
        action,
        link,
        params,
        query: pageQuery,
        type: rdxAction.type,
      });

      if (!response.success || !response.data) {
        break;
      }

      const pageData = response.data;
      const pageFiles = Array.isArray(pageData.data) ? pageData.data : [];

      for (const file of pageFiles) {
        const filename = file.attributes?.filename;
        if (filename) {
          allFiles.push({ id: file.id, filename });
        }
      }

      const pagination = pageData?.meta?.pagination;
      if (pagination && pagination.page < pagination.pageCount) {
        currentPage = pagination.page + 1;
      } else {
        hasMore = false;
      }
    }

    yield put(resetProcedureStepFiles());
    if (allFiles.length) {
      yield put(setProcedureStepFiles(allFiles));
    }
  } finally {
    yield put(setLoadingAllProcedureStepFiles(false));
  }
}

export default fetchAllProcedureStepFiles;
